import { Autocomplete, DatePicker, Input } from '@fullscreendigital/carrefour-dex-fe'
import dayjs from 'dayjs'
import { AddActionIcon, DownloadIcon } from '../../../../../icons'
import { formatTime, formatUIDate } from '../../../../../utils/helpers'
import { AsyncAutocompleteOption } from 'components/core-ui/AsyncAutocomplete/AsyncAutocompleteDefinitions'

export const toolbarActions = ({
  totalCount,
  exportFileExcel,
  isExcelExportLoading,
  openNewModal
}) => {
  let actions = [
    {
      label: 'Proces verbal',
      icon: <AddActionIcon />,
      onClick: openNewModal
    }
  ]

  if (totalCount > 0 && totalCount <= 1000) {
    actions = [
      ...actions,
      {
        label: isExcelExportLoading ? 'Export in curs...' : 'Export Excel',
        icon: <DownloadIcon />,
        onClick: isExcelExportLoading ? () => {} : exportFileExcel
      }
    ]
  }

  return actions
}

export const statusColorMapping = {
  Înregistrat: 'orange',
  'În predare': 'blue',
  Procesat: 'black',
  Predat: 'green',
  'Parțial trimis la meti': 'blue',
  'Trimis la Meti': 'green',
  Resigilat: 'orange',
  'Expediat din HUB': 'orange',
  'În procesare în HUB': 'blue',
  Succes: 'green',
  Lipsește: 'red',
  'În aşteptare': 'black',
  Expediat: 'orange'
}

export const getColumns = () => [
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'ID Returo',
    field: 'idReturo',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Numar PV',
    field: 'noticeNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Numar CMR',
    field: 'cmrNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Datǎ inregistrare',
    field: 'created',
    align: 'left',
    type: 'string',
    render: row => `${formatUIDate(row.created)} ${formatTime(row.created)}`
  },
  {
    title: 'Operator',
    field: 'createdBy',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Status',
    field: 'status',
    align: 'left',
    type: 'string',
    render: row => (
      <div style={{ color: statusColorMapping[row.statusValue] || 'black' }}>{row.statusValue}</div>
    )
  },
  {
    title: 'Nume companie colectoare',
    field: 'providerName',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Numar camion',
    field: 'truckNumber',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Nume sofer',
    field: 'driverName',
    align: 'left',
    type: 'string'
  }
]

export const materialTypes = [
  {
    label: 'Cuvă',
    value: 'VAT'
  },
  {
    label: 'Sac',
    value: 'SACK'
  }
]

export const drawerFilters = (
  shopOptions: AsyncAutocompleteOption[],
  statusOptions: AsyncAutocompleteOption[]
) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Selectează magazin'
  },
  {
    name: 'materialType',
    value: '',
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selectează tip material"
        disableClearable
        options={materialTypes || []}
      />
    ),
    type: 'autocomplete',
    label: 'Selectează tip material'
  },
  {
    name: 'cmrNumber',
    filter: <Input variant="outlined" label="Numar CMR" type="text" />,
    type: 'text',
    label: 'Numar CMR'
  },
  {
    name: 'providerName',
    filter: <Input variant="outlined" label="Nume companie colectoare" type="text" />,
    type: 'text',
    label: 'Nume companie colectoare'
  },
  {
    name: 'createdBy',
    filter: <Input variant="outlined" label="Nume operator" type="text" />,
    type: 'text',
    label: 'Nume operator'
  },
  {
    name: 'status',
    value: undefined,
    filter: <Autocomplete variant="outlined" label="Status" options={statusOptions || []} />,
    type: 'autocomplete',
    label: 'Status'
  },
  {
    name: 'created',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data de inceput"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de inceput',
    disableFuture: true
  },
  {
    name: 'createdTo',
    value: '',
    filter: (
      <DatePicker
        label="Selecteaza data de sfarsit"
        variant="outlined"
        value={dayjs()}
        onChange={() => {}}
        adapterLocale="ro"
        modalLabel="Selecteaza data"
        closeButtonLabel="Anuleaza"
        confirmButtonLabel="Confirma"
      />
    ),
    type: 'date',
    label: 'Selecteaza data de sfarsit',
    disableFuture: true
  }
]
